import {h, Fragment} from "preact"
import { AutocompleteElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import Swatches  from "./Swatches"
import QuickShop  from "./QuickShop"
import { productImagePlaceholder } from "../helpers"

export default function Product({ product, relatedProducts }) {
    const { format } = useCurrencyFormatting()
    const badge = useMemo(() => product?.tags1?.find(tag => tag.includes('__label'))?.split("__")[0], []);
    var colorStyle = useMemo(() => product?.skus?.[0]?.customFields?.find(attr => attr.key == "color")?.value, []) || '';
    colorStyle = colorStyle.toLowerCase().replaceAll(" ", "-");
    var isGiftCard = product.categories.includes("Gift Cards");

    const saleMessage = () => {
      if (window.nostoSaleNotice && window.nostoSaleNotice.active) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;
    
        if (window.nostoSaleNotice.start_date < formattedDate && window.nostoSaleNotice.end_date > formattedDate) {
          // let nostoCat = product.categories;
          // let nostoCat = product.categoryIds;
          // let nostoTags = product.tags1;

          let nostoCat = product.categoryIds;
          let catContained = false;
          if(window.nostoSaleNotice.collections.length == 0) {
            catContained = true;
          } else {
            for (const saleCollection of window.nostoSaleNotice.collections) {
              if (nostoCat.includes(saleCollection)) {
                catContained = true;
              }
            }
          }

          let nostoTags = product.tags1;
          let tagContained = false;
          if(window.nostoSaleNotice.tags.length == 0) {
            tagContained = true;
          } else {
            for (const saleTag of window.nostoSaleNotice.tags) {
              if (nostoTags.includes(saleTag)) {
                tagContained = true;
              }
            }
          }

          if (tagContained && catContained) {
            return <span style={{ color: window.nostoSaleNotice.notice_color }} dangerouslySetInnerHTML={{ __html: window.nostoSaleNotice.notice }} />
          }

          //Check both tags and collections
          // for (const collection of window.nostoSaleNotice.collections) {
          //   if (nostoCat.includes(collection)) {
          //     if (window.nostoSaleNotice.tags) {
          //       for (const tag of window.nostoSaleNotice.tags) {
          //         if (nostoTags.includes(tag)) {
          //           return <span style={{ color: window.nostoSaleNotice.notice_color }} dangerouslySetInnerHTML={{ __html: window.nostoSaleNotice.notice }} />
          //         }
          //       }
          //     } else {
          //       return <span style={{ color: window.nostoSaleNotice.notice_color }} dangerouslySetInnerHTML={{ __html: window.nostoSaleNotice.notice }} />
          //     }
          //   }
          // }
        }
      }
      return null;
    };    

    return (
        <AutocompleteElement
            as="div"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit card-wrapper item"
        >
          <a href={product.url}>
              <div class="ns-image-wrap">
                  {badge && <div class="card__badge"><span>{badge}</span></div>}
                <img
                  class="ns-image"
                  alt={product.name}
                  title={product.name}
                  loading="lazy"
                  src={product.imageUrl ?? productImagePlaceholder}
                  style="width: 100%"
                />
                <div class="ns-alt-img">
                  <img
                    class="ns-image"
                    alt={product.name}
                    title={product.name}
                    src={`${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}`}
                    style="width: 100%"
                  />
                </div>
                <p 
                  class="quick-shop" 
                  onClick={(e) => {e.preventDefault(); e.target.closest(".ns-product")?.querySelector(".quick-shop-wrapper")?.classList.toggle("ns-d-block")}}
                >Quick Shop</p>
                <div 
                  class="quick-shop-mobile" 
                  onClick={(e) => {e.preventDefault(); document.querySelector(`.quick-shop-wrapper[productId='${product.productId}']`).showModal()}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11077 5.40178C0.948784 5.40178 0.793432 5.46609 0.67889 5.58057C0.564349 5.69505 0.5 5.85031 0.5 6.01221C0.5 6.1741 0.564349 6.32937 0.67889 6.44385C0.793432 6.55833 0.948784 6.62264 1.11077 6.62264H5.38616L5.39838 10.8956C5.39918 10.9758 5.41577 11.055 5.44721 11.1288C5.47864 11.2025 5.5243 11.2694 5.58159 11.3255C5.63887 11.3816 5.70665 11.4259 5.78106 11.4558C5.85547 11.4858 5.93505 11.5008 6.01525 11.5C6.09546 11.4992 6.17473 11.4826 6.24852 11.4512C6.32232 11.4197 6.3892 11.3741 6.44534 11.3169C6.50149 11.2596 6.54581 11.1919 6.57576 11.1175C6.60571 11.0431 6.62072 10.9636 6.61992 10.8834V6.61043L10.8953 6.59822C10.9755 6.59742 11.0548 6.58084 11.1286 6.54942C11.2024 6.518 11.2692 6.47236 11.3254 6.41511C11.3815 6.35786 11.4259 6.29012 11.4558 6.21575C11.4858 6.14139 11.5008 6.06185 11.5 5.98169C11.4992 5.90152 11.4826 5.8223 11.4511 5.74855C11.4197 5.6748 11.374 5.60795 11.3168 5.55184C11.2595 5.49572 11.1917 5.45143 11.1173 5.42149C11.0429 5.39156 10.9633 5.37656 10.8831 5.37736H6.6077L6.59549 1.10436C6.59387 0.94246 6.52796 0.787838 6.41228 0.674505C6.29659 0.561172 6.14059 0.498412 5.97861 0.500031C5.81662 0.50165 5.66191 0.567515 5.54852 0.683138C5.43512 0.79876 5.37233 0.954668 5.37395 1.11656V5.38957L1.09855 5.40178H1.11077Z" fill="black"/>
                    </svg>
                </div>
                <QuickShop product={product} relatedProducts={ relatedProducts } isMobile={window.innerWidth < 768} />
              </div>
              <div class="ns-info-wrap">
                <div class="ns-info-title left">{product.name}</div>
                <div class="ns-price-wrap left">
                  <span class={`ns-price ns-listprice  ${product.onDiscount ? '' : 'ns-hidden'}`}>{format(product.listPrice)}</span>
                  <span class={`ns-price ns-current-price ${product.onDiscount ? 'discounted' : ''}`}>{format(product.price)}</span>
                </div>
                {relatedProducts.length > 0 && <Swatches relatedProducts={ relatedProducts } product={product} />}
                {!isGiftCard && relatedProducts.length == 0 && 
                  <div class="ns-colors custom-color-selectors">
                    <a href={product.url} class="ns-color first active" title={product.name}>
                        <span class={`ns-swatch ns-color-${colorStyle} first active`} style={`background: ${colorStyle};`}></span>
                    </a>
                  </div>
                }
                <div class="ns-sale-notice">{saleMessage()}</div>
              </div>
          </a>
        </AutocompleteElement>
    )
}
